// extracted by mini-css-extract-plugin
export default {"item":"src-modules-page-blocks-Checklist-style__item_tRLAm","checkmark":"src-modules-page-blocks-Checklist-style__checkmark_PNc8i"};